import { useState } from 'react';
import {
  getAuth,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from 'firebase/auth';

const usePasswordManagement = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [isConfirmPasswordModalOpen, setIsConfirmPasswordModalOpen] =
    useState(false);
  const [message, setMessage] = useState('');

  const auth = getAuth();
  const user = auth.currentUser;

  const handleReauthenticate = async () => {
    const credential = EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    try {
      await reauthenticateWithCredential(user, credential);
      return true;
    } catch (error) {
      setMessage('Erro ao reautenticar: ' + error.message);
      return false;
    }
  };

  const handleChangePassword = async () => {
    if (newPassword !== confirmNewPassword) {
      setMessage('As senhas não coincidem.');
      return;
    }

    const reauthenticated = await handleReauthenticate();
    if (reauthenticated) {
      try {
        await updatePassword(user, newPassword);
        setMessage('Senha atualizada com sucesso!');
      } catch (error) {
        setMessage('Erro ao atualizar senha: ' + error.message);
      } finally {
        setCurrentPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
        setIsConfirmPasswordModalOpen(false);
      }
    }
  };

  return {
    currentPassword,
    newPassword,
    confirmNewPassword,
    isConfirmPasswordModalOpen,
    message,
    setCurrentPassword,
    setNewPassword,
    setConfirmNewPassword,
    setIsConfirmPasswordModalOpen,
    setMessage,
    handleChangePassword,
  };
};

export default usePasswordManagement;
